import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { PrivateRouteUser } from './components/PrivateRoute';
import Logout from './scenes/Logout';
import Loading from './components/Loading';
import App from './App';
import withTracker from './utils/googleAnalytics';
import AuthError from './scenes/AuthError';
import AuthVerifyEmail from './scenes/AuthError/verifyEmail';
import { routeUrl } from './LinkUrl';
import Callback from './scenes/Callback';
/**
 * For design, TODO: remove from master
 */
import DashboardDesign from './scenes/Students/Design/DashboardTemp';

export const Home = React.lazy(() => import('./scenes/Students/Home'));
export const EntranceExam = React.lazy(() => import('./scenes/Students/EntranceExam'));
export const ProgramList = React.lazy(() => import('./scenes/Students/ProgramList'));
export const SignUpInfo = React.lazy(() => import('./scenes/Students/Profile/SignupProfile'));
export const OnBoarding = React.lazy(() => import('./scenes/Students/Onboarding'));
export const ApplicationForm = React.lazy(() => import('./scenes/Students/ApplicationForm'));
export const Certificate = React.lazy(() => import('./scenes/Students/Certificate'));
export const Maintainance = React.lazy(() => import('./scenes/404/maintanance'));
export const ErrorPage = React.lazy(() => import('./scenes/404/'));

const MainRoutes = () => {
  /**
   * NOTE: if user(!loggedin) directly access /student/..,saves its desired route, inorder to redirect when user logs in.
   */
  if (window.location.pathname.includes('/student')) {
    sessionStorage.setItem('ROUTE_STATE', window.location.pathname);
  }

  return (
    <React.Suspense fallback={<Loading pastDelay={true} />}>
      <Switch>
        <Route exact path={["/login", "/"]} component={App} />
        <Route path="/callback" component={Callback} />
        <Route exact path="/logout" component={Logout} />
        <Route exact path="/certificate/:courseId" component={Certificate} />
        <Route exact path="/error" component={AuthError} />
        <Route exact path="/verifyEmail" component={AuthVerifyEmail} />
        <Route exact path="/404" component={ErrorPage} />
        <Route exact path="/maintenance" component={Maintainance} />
        {/* For design, TODO: remove from master */}
        <PrivateRouteUser path="/design_temp" component={DashboardDesign} />
        {/* <PrivateRouteUser path="/dashboard" component={Dashboard} /> */}
        <PrivateRouteUser path={'/challenge'} exact component={withTracker(EntranceExam)} />
        <PrivateRouteUser path={'/programList'} exact component={withTracker(ProgramList)} />
        <PrivateRouteUser path={routeUrl.student.school} exact component={withTracker(ProgramList)} />
        <PrivateRouteUser path="/application" component={withTracker(ApplicationForm)} />
        <PrivateRouteUser path={routeUrl.student.signUpInfo} component={SignUpInfo} />
        <PrivateRouteUser path={routeUrl.student.onboarding} component={OnBoarding} />
        <PrivateRouteUser path='/' component={withTracker(Home)} />
        <Route component={ErrorPage} />
      </Switch>
    </React.Suspense>
  )
};

export default MainRoutes;
